// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/gantry/v1/gantry.proto" (package "viam.component.gantry.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetKinematicsResponse } from "../../../common/v1/common";
import { GetKinematicsRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.gantry.v1.GetPositionRequest
 */
export interface GetPositionRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.GetPositionResponse
 */
export interface GetPositionResponse {
    /**
     * @generated from protobuf field: repeated double positions_mm = 1;
     */
    positionsMm: number[];
}
/**
 * @generated from protobuf message viam.component.gantry.v1.MoveToPositionRequest
 */
export interface MoveToPositionRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Number of millimeters to move the gantry by respective to each axis.
     *
     * @generated from protobuf field: repeated double positions_mm = 2;
     */
    positionsMm: number[];
    /**
     * Speeds to move each gantry axis must match length and order of positions_mm.
     *
     * @generated from protobuf field: repeated double speeds_mm_per_sec = 3;
     */
    speedsMmPerSec: number[];
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.MoveToPositionResponse
 */
export interface MoveToPositionResponse {
}
/**
 * @generated from protobuf message viam.component.gantry.v1.HomeRequest
 */
export interface HomeRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.HomeResponse
 */
export interface HomeResponse {
    /**
     * A bool describing whether the gantry has completed homing
     *
     * @generated from protobuf field: bool homed = 1;
     */
    homed: boolean;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.GetLengthsRequest
 */
export interface GetLengthsRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.GetLengthsResponse
 */
export interface GetLengthsResponse {
    /**
     * @generated from protobuf field: repeated double lengths_mm = 1;
     */
    lengthsMm: number[];
}
/**
 * @generated from protobuf message viam.component.gantry.v1.StopRequest
 */
export interface StopRequest {
    /**
     * Name of a gantry
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.StopResponse
 */
export interface StopResponse {
}
/**
 * @generated from protobuf message viam.component.gantry.v1.Status
 */
export interface Status {
    /**
     * @generated from protobuf field: repeated double positions_mm = 1;
     */
    positionsMm: number[];
    /**
     * @generated from protobuf field: repeated double lengths_mm = 2;
     */
    lengthsMm: number[];
    /**
     * @generated from protobuf field: bool is_moving = 3;
     */
    isMoving: boolean;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.IsMovingRequest
 */
export interface IsMovingRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.component.gantry.v1.IsMovingResponse
 */
export interface IsMovingResponse {
    /**
     * @generated from protobuf field: bool is_moving = 1;
     */
    isMoving: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionRequest$Type extends MessageType<GetPositionRequest> {
    constructor() {
        super("viam.component.gantry.v1.GetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.GetPositionRequest
 */
export const GetPositionRequest = new GetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionResponse$Type extends MessageType<GetPositionResponse> {
    constructor() {
        super("viam.component.gantry.v1.GetPositionResponse", [
            { no: 1, name: "positions_mm", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.GetPositionResponse
 */
export const GetPositionResponse = new GetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToPositionRequest$Type extends MessageType<MoveToPositionRequest> {
    constructor() {
        super("viam.component.gantry.v1.MoveToPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "positions_mm", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "speeds_mm_per_sec", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.MoveToPositionRequest
 */
export const MoveToPositionRequest = new MoveToPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToPositionResponse$Type extends MessageType<MoveToPositionResponse> {
    constructor() {
        super("viam.component.gantry.v1.MoveToPositionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.MoveToPositionResponse
 */
export const MoveToPositionResponse = new MoveToPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HomeRequest$Type extends MessageType<HomeRequest> {
    constructor() {
        super("viam.component.gantry.v1.HomeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.HomeRequest
 */
export const HomeRequest = new HomeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HomeResponse$Type extends MessageType<HomeResponse> {
    constructor() {
        super("viam.component.gantry.v1.HomeResponse", [
            { no: 1, name: "homed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.HomeResponse
 */
export const HomeResponse = new HomeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLengthsRequest$Type extends MessageType<GetLengthsRequest> {
    constructor() {
        super("viam.component.gantry.v1.GetLengthsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.GetLengthsRequest
 */
export const GetLengthsRequest = new GetLengthsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLengthsResponse$Type extends MessageType<GetLengthsResponse> {
    constructor() {
        super("viam.component.gantry.v1.GetLengthsResponse", [
            { no: 1, name: "lengths_mm", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.GetLengthsResponse
 */
export const GetLengthsResponse = new GetLengthsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopRequest$Type extends MessageType<StopRequest> {
    constructor() {
        super("viam.component.gantry.v1.StopRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.StopRequest
 */
export const StopRequest = new StopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopResponse$Type extends MessageType<StopResponse> {
    constructor() {
        super("viam.component.gantry.v1.StopResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.StopResponse
 */
export const StopResponse = new StopResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("viam.component.gantry.v1.Status", [
            { no: 1, name: "positions_mm", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "lengths_mm", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.Status
 */
export const Status = new Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingRequest$Type extends MessageType<IsMovingRequest> {
    constructor() {
        super("viam.component.gantry.v1.IsMovingRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.IsMovingRequest
 */
export const IsMovingRequest = new IsMovingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingResponse$Type extends MessageType<IsMovingResponse> {
    constructor() {
        super("viam.component.gantry.v1.IsMovingResponse", [
            { no: 1, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.gantry.v1.IsMovingResponse
 */
export const IsMovingResponse = new IsMovingResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.gantry.v1.GantryService
 */
export const GantryService = new ServiceType("viam.component.gantry.v1.GantryService", [
    { name: "GetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/position" } }, I: GetPositionRequest, O: GetPositionResponse },
    { name: "MoveToPosition", options: { "google.api.http": { put: "/viam/api/v1/component/gantry/{name}/position" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveToPositionRequest, O: MoveToPositionResponse },
    { name: "Home", options: { "google.api.http": { put: "/viam/api/v1/component/gantry/{name}/home" } }, I: HomeRequest, O: HomeResponse },
    { name: "GetLengths", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/lengths" } }, I: GetLengthsRequest, O: GetLengthsResponse },
    { name: "Stop", options: { "google.api.http": { post: "/viam/api/v1/component/gantry/{name}/stop" } }, I: StopRequest, O: StopResponse },
    { name: "IsMoving", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/is_moving" } }, I: IsMovingRequest, O: IsMovingResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/gantry/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetKinematics", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/kinematics" } }, I: GetKinematicsRequest, O: GetKinematicsResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/gantry/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse }
]);
